module.exports = __webpack_public_path__ + "img/swirlmarks.c8010c15.jpeg";